function observeWidgetPrice() {
  const widget = document.querySelector("recharge-subscription-widget");
  console.log('widgetwidgetwidget 1', widget)
  if (!widget || !widget.shadowRoot) {
    console.log('Widget or shadowRoot not found, setting up body observer...');
    const bodyObserver = new MutationObserver(() => {
      const w = document.querySelector("recharge-subscription-widget");
      console.log('wwwww 1', w)
      if (w && w.shadowRoot) {
        console.log('Widget found with shadowRoot, starting observer...');
        bodyObserver.disconnect();
        startObserver(w.shadowRoot);
      }
    });
    bodyObserver.observe(document.body, { childList: true, subtree: true });
    return;
  }

  console.log('Widget found immediately, starting observer...');
  startObserver(widget.shadowRoot);
}

function updateDiscountInWidget() {
  const widget = document.querySelector("recharge-subscription-widget");
  console.log('widgetwidgetwidgetwidget', widget)
  if (!widget || !widget.shadowRoot) {
    console.log('Widget or shadowRoot not available in updateDiscountInWidget');
    return;
  }
  
  // Wait for content to be loaded - check if we have enough elements
  const allElements = widget.shadowRoot.querySelectorAll('*');
  console.log('All elements in shadow root:', allElements.length);
  
  if (allElements.length < 10) {
    console.log('Shadow root content not fully loaded yet, waiting...');
    setTimeout(() => {
      updateDiscountInWidget();
    }, 500);
    return;
  }
  
  // Now try to find the one-time price element directly
  const oneTimePriceElement = widget.shadowRoot.querySelector(".rc-selection__onetime .rc-price");
  console.log('oneTimePriceElement', oneTimePriceElement);
  
  if (!oneTimePriceElement) {
    console.log('One time price element not found');
    // Debug: Let's see what elements are available
    const elementsWithOnetime = Array.from(allElements).filter(el => 
      el.className && el.className.includes('onetime')
    );
    console.log('Elements with onetime in class:', elementsWithOnetime);
    return;
  }
  
  // Check if we've already processed this variant to avoid infinite loops
  const productSelect = document.getElementById("ProductSelect");
  if (!productSelect) {
    console.log('ProductSelect not found');
    return;
  }
  
  const currentVariantId = productSelect.value;
  console.log('Current variant ID:', currentVariantId);
  
  // Check if we've already processed this variant
  if (oneTimePriceElement.dataset.lastProcessedVariant === currentVariantId) {
    console.log('Variant already processed, skipping...');
    return;
  }
  
  console.log("Processing discount for variant:", currentVariantId);
  
  // Get variants data from the main page
  // const variantsJsonElement = document.getElementById("variants-json");
  // if (!variantsJsonElement) {
  //   console.log("Variants JSON element not found");
  //   return;
  // }
  
  // try {
  //   const variants = JSON.parse(variantsJsonElement.textContent);
  //   const variant = variants.find(v => v.id == currentVariantId);
  //   console.log('Found variant:', variant);
    
  //   if (variant && variant.otp_discount && !isNaN(parseFloat(variant.otp_discount))) {
  //     const discount = parseFloat(variant.otp_discount);
  //     console.log("Processing discount:", discount);
      
  //     // Remove existing discount text if present
  //     const existingDiscountText = oneTimePriceElement.querySelector(".m-otp-text");
  //     if (existingDiscountText) {
  //       existingDiscountText.remove();
  //     }
      
  //     // Append the discount text
  //     const discountSpan = document.createElement("span");
  //     discountSpan.className = "m-otp-text";
  //     discountSpan.textContent = " Save " + discount + "%";
  //     discountSpan.style.color = "#00ba74";
  //     discountSpan.style.paddingLeft = "10px";
  //     discountSpan.style.fontWeight = "600";
  //     discountSpan.setAttribute("part", "m-otp-text");
  //     oneTimePriceElement.appendChild(discountSpan);

  //     console.log('121212121')
      
  //     // Mark as processed
  //     oneTimePriceElement.dataset.lastProcessedVariant = currentVariantId;
  //     console.log("Discount text appended successfully");
  //   } else {
  //     console.log("No valid discount found for variant");
  //     // Remove discount text if no discount or invalid discount
  //     const existingDiscountText = oneTimePriceElement.querySelector(".m-otp-text");
  //     if (existingDiscountText) {
  //       existingDiscountText.remove();
  //     }
  //     // Mark as processed
  //     oneTimePriceElement.dataset.lastProcessedVariant = currentVariantId;
  //   }
  // } catch (e) {
  //   console.error("Error processing OTP discount:", e);
  // }

  const variantsJsonElement = document.getElementById("variants-json");
if (!variantsJsonElement) {
  console.log("Variants JSON element not found");
  return;
}

try {
  const variants = JSON.parse(variantsJsonElement.textContent);
  const variant = variants.find(v => v.id == currentVariantId);
  console.log('Found variant:', variant);

  // Remove existing discount text if present
  let existingDiscountText = oneTimePriceElement.querySelector(".m-otp-text");
  if (existingDiscountText) existingDiscountText.remove();

  // Remove existing discounted price if present
  let discountedEl = oneTimePriceElement.parentElement.querySelector('[part="rc-purchase-option__discounted-price"]');
  if (discountedEl) discountedEl.remove();

  if (variant && variant.otp_discount && !isNaN(parseFloat(variant.otp_discount))) {
    const discount = parseFloat(variant.otp_discount);
    console.log("Processing discount:", discount);

    // --- Append the discount text ---
    const discountSpan = document.createElement("span");
    discountSpan.className = "m-otp-text";
    discountSpan.textContent = ` Save ${discount}%`;
    discountSpan.style.color = "#00ba74";
    discountSpan.style.paddingLeft = "10px";
    discountSpan.style.fontWeight = "600";
    discountSpan.setAttribute("part", "m-otp-text");
    oneTimePriceElement.appendChild(discountSpan);

    // --- Compute discounted price ---
    const priceMatch = oneTimePriceElement.textContent.match(/[\d,.]+/);
    if (priceMatch) {
      const originalPrice = parseFloat(priceMatch[0].replace(',', ''));
      const discountedRaw = originalPrice * (1 - discount / 100);
      const discountedPrice = Math.ceil(discountedRaw * 100) / 100;
      const formattedPrice = `$${discountedPrice.toFixed(2)}`;

      // --- Set original price part ---
      oneTimePriceElement.setAttribute("part", "rc-purchase-option__original-price");

      // --- Insert discounted price span ---
      discountedEl = document.createElement("span");
      discountedEl.setAttribute("part", "rc-purchase-option__discounted-price");
      discountedEl.className = "rc-price";
      discountedEl.style.marginLeft = "8px";
      discountedEl.textContent = formattedPrice;
      oneTimePriceElement.insertAdjacentElement('afterend', discountedEl);
    }

    console.log("Discount text and discounted price appended successfully");
  } else {
    console.log("No valid discount found for variant");
    oneTimePriceElement.setAttribute("part", "rc-purchase-option__price");
  }

  // Mark as processed
  oneTimePriceElement.dataset.lastProcessedVariant = currentVariantId;

} catch (e) {
  console.error("Error processing OTP discount:", e);
}

}

function startObserver(shadowRoot) {
  console.log('Starting observer on shadow root...');
  let isProcessing = false;
  
  const observer = new MutationObserver((mutations) => {
    console.log('Mutation observer triggered, mutations count:', mutations.length);
    
    // Prevent multiple simultaneous processing
    if (isProcessing) {
      console.log('Already processing, skipping...');
      return;
    }
    
    // Check if any mutation affects the one-time price element
    const hasPriceChanges = mutations.some(mutation => {
      // Check if target is an Element before calling closest
      if (mutation.target.nodeType !== Node.ELEMENT_NODE) {
        return false;
      }
      
      // Check if the mutation affects the one-time price element
      const isPriceChange = mutation.target.closest('.rc-selection__onetime .rc-price') ||
                           (mutation.target.classList.contains('rc-price') && 
                            mutation.target.closest('.rc-selection__onetime')) ||
                           mutation.target.closest('.rc-selection__onetime');
      
      console.log('Mutation affects price:', isPriceChange, 'Target:', mutation.target);
      
      return isPriceChange;
    });
    
    if (!hasPriceChanges) {
      console.log('No relevant price changes detected');
      return;
    }
    
    console.log('Price changes detected, processing...');
    
    isProcessing = true;
    
    // Use requestAnimationFrame to batch updates
    requestAnimationFrame(() => {
      updateDiscountInWidget();
      isProcessing = false;
    });
  });

  observer.observe(shadowRoot, {
    childList: true,
    subtree: true,
    characterData: false, // Disable character data observation to reduce triggers
  });
  
  // Also try to update immediately in case elements are already there
  setTimeout(() => {
    console.log('Trying immediate update...');
    updateDiscountInWidget();
  }, 1000);
}

// Listen for variant changes on the main page
function listenForVariantChanges() {
  console.log('Setting up variant change listeners...');
  const productSelect = document.getElementById("ProductSelect");
  if (productSelect) {
    console.log('ProductSelect found, adding change listener');
    productSelect.addEventListener('change', () => {
      console.log("Variant changed, triggering discount update...");
      // Wait a bit for the widget to update
      setTimeout(() => {
        updateDiscountInWidget();
      }, 200);
    });
  } else {
    console.log('ProductSelect not found');
  }
  
  // Also listen for custom variant change events
  document.addEventListener('variantChange', () => {
    console.log("Variant change event detected, updating discount...");
    setTimeout(() => {
      updateDiscountInWidget();
    }, 200);
  });
}

// Wait for DOM to be ready
if (document.readyState === 'loading') {
  console.log('DOM still loading, waiting for DOMContentLoaded...');
  document.addEventListener('DOMContentLoaded', () => {
    console.log('DOMContentLoaded fired, initializing...');
    observeWidgetPrice();
    listenForVariantChanges();
  });
} else {
  console.log('DOM already ready, initializing immediately...');
  observeWidgetPrice();
  listenForVariantChanges();
}
